import { ProductGroup } from '@/gql/graphql';

export const isProductGroupEditEnabled = (userId: string, productGroup?: ProductGroup) => {
  if (!productGroup) return false;
  return productGroup.owner === userId;
};

export const isProductGroupDeleteEnabled = (userId: string, productGroup?: ProductGroup) => {
  if (!productGroup) return false;
  return productGroup.members.length === 0 && productGroup.owner === userId;
};
